import axios from 'axios';
class PagesService {
  async getPageByName(pageName) {
    var page = await axios.get('https://api.iddigital.com.au/api/v1/pages/getPageByName/' + pageName)
    console.log('from service-->>', page)
    return page.data.body.page;
  }

}
export default PagesService;